"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Strategies = void 0;

var _react = _interopRequireWildcard(require("react"));

var _toArray2 = _interopRequireDefault(require("lodash/toArray"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Strategies = {
  /**
   * Simple select strategy - selects one value at a time
   */
  simple: {
    isSelected: function isSelected(selectedValue, value) {
      return selectedValue === value;
    },
    update: function update(_, value) {
      return value;
    }
  },
  switchable: {
    isSelected: function isSelected(selectedValue, value) {
      return selectedValue === value;
    },
    update: function update(selectedValue, value) {
      return selectedValue === value ? undefined : value;
    }
  },

  /**
   * Multi-select strategy
   */
  multi: {
    getInitialValue: _toArray2["default"],
    isSelected: function isSelected(selectedValue, value) {
      return selectedValue.indexOf(value) !== -1;
    },
    update: function update(_ref, value) {
      var _ref2 = _toArray(_ref),
          selectedValue = _ref2.slice(0);

      var index = selectedValue.indexOf(value);
      if (index === -1) selectedValue.push(value);else selectedValue.splice(index, 1);
      return selectedValue;
    }
  }
};
exports.Strategies = Strategies;

var defaultGetValue = function defaultGetValue(node) {
  return node.props.value;
};

var GroupItem =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(GroupItem, _PureComponent);

  function GroupItem() {
    _classCallCheck(this, GroupItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(GroupItem).apply(this, arguments));
  }

  _createClass(GroupItem, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_react["default"].Fragment, null, this.props[GroupItem.childrenProp]);
    }
  }]);

  return GroupItem;
}(_react.PureComponent);

_defineProperty(GroupItem, "childrenProp", '$$groupItem');

var Group = function Group(parseProps) {
  var getValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultGetValue;
  return function (Target) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_PureComponent2) {
      _inherits(SelectGroup, _PureComponent2);

      function SelectGroup() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, SelectGroup);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "state", {});

        _defineProperty(_assertThisInitialized(_this), "isSelected", function (value) {
          return _this.state.strategy.isSelected(_this.state.selectedValue, value);
        });

        _defineProperty(_assertThisInitialized(_this), "update", function (value) {
          return _this.state.strategy.update(_this.state.selectedValue, value);
        });

        _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
          var disabled = _this.props.disabled;
          if (disabled) return;

          var selectedValue = _this.update(value);

          var onChange = function onChange() {
            if (_this.props.onChange) _this.props.onChange(selectedValue);
          };

          if (_this.state.isControlled) onChange();else _this.setState({
            selectedValue: selectedValue
          }, onChange);
        });

        _defineProperty(_assertThisInitialized(_this), "_childProps", function (node, index) {
          var value = getValue(node, index);
          var nextProps = parseProps(_objectSpread({}, _this.props, {
            selectedValue: _this.state.selectedValue,
            onSelect: function onSelect() {
              return _this.onChange(value);
            },
            selected: _this.isSelected(value)
          }), node);
          return (0, _omit["default"])(nextProps, Object.keys(node.props));
        });

        _defineProperty(_assertThisInitialized(_this), "renderItem", function (child, index) {
          var renderItem = _this.props.renderItem;
          if (!child) return;

          var component = _react["default"].cloneElement(child, _this._childProps(child, index));

          if (!renderItem) return component; // Wrap item to ensure the Target component has access to child props
          // when `renderItem` is passed

          return _react["default"].createElement(GroupItem, _objectSpread({}, component.props, _defineProperty({}, GroupItem.childrenProp, renderItem(component, _this.props))));
        });

        return _this;
      }

      _createClass(SelectGroup, [{
        key: "render",
        value: function render() {
          return _react["default"].createElement(Target, _extends({
            ref: this.props.innerRef
          }, this.props, this.state, {
            onSelect: this.onChange
          }), _react["default"].Children.map(this.props.children, this.renderItem));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(props, state) {
          var isControlled = typeof props.selectedValue !== 'undefined';
          var strategy = state.strategy || props.strategy;
          var initialValue = props.initialValue;
          if (typeof strategy === 'string' && strategy in Strategies) strategy = Strategies[strategy];
          if (strategy.getInitialValue) initialValue = strategy.getInitialValue(initialValue);
          return {
            isControlled: isControlled,
            strategy: strategy,
            selectedValue: isControlled ? props.selectedValue : 'selectedValue' in state ? state.selectedValue : initialValue
          };
        }
      }]);

      return SelectGroup;
    }(_react.PureComponent), _defineProperty(_class, "propTypes", _objectSpread({
      strategy: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(Object.keys(Strategies)), _propTypes["default"].shape({
        /**
         * Get default initial value
         * @param {any} initialValue
         * @returns {any}
         */
        getInitialValue: _propTypes["default"].func,

        /**
         * Test if a value is selected
         * @param {any} selectedValue Selected value
         * @param {any} value Value to check against
         * @returns {Boolean}
         */
        isSelected: _propTypes["default"].func.isRequired,

        /**
         * Update the selected value
         * @param {any} selectedValue Selected value
         * @param {any} value Value to select
         * @returns {any} New value
         */
        update: _propTypes["default"].func.isRequired
      })]).isRequired,
      children: _propTypes["default"].node.isRequired,
      selectedValue: _propTypes["default"].any,
      disabled: _propTypes["default"].bool,
      onChange: _propTypes["default"].func,
      renderItem: _propTypes["default"].func
    }, Target.propTypes || {})), _defineProperty(_class, "defaultProps", Object.assign({
      strategy: Strategies.simple
    }, Target.defaultProps || {})), _temp;
  };
};

Group.Strategies = Strategies;
var _default = Group;
exports["default"] = _default;